import React from "react";
import Calendar from "react-calendar";
import { useLocation, useSearchParams } from "react-router-dom";
import moment from "moment";
import styles from "./DateRangeFilter.module.scss";

interface DateRangeFilterProps {
  className?: string;
  showHeader?: boolean;
}

export default function DateRangeFilter({
  className = "",
  showHeader = true,
}: DateRangeFilterProps) {
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();

  // Get current date range from URL params
  const createdFrom = searchParams.get("createdFrom");
  const createdTo = searchParams.get("createdTo");

  // Handle date range selection
  const handleDateChange = (val: any) => {
    if (val && Array.isArray(val)) {
      const from = moment(val[0]).format("YYYY-MM-DD");
      const to = moment(val[1]).format("YYYY-MM-DD");
      const newSearchParams = new URLSearchParams(location.search);
      newSearchParams.set("createdFrom", from);
      newSearchParams.set("createdTo", to);
      setSearchParams(newSearchParams.toString());
    }
  };

  return (
    <div className={`${styles.dateRangeFilter} ${className}`}>
      {showHeader && (
        <div className={styles.smallHeader}>Datum dospeća RFZO terapije</div>
      )}
      <Calendar
        selectRange={true}
        returnValue="range"
        value={[
          createdFrom ? new Date(createdFrom) : null,
          createdTo ? new Date(createdTo) : null,
        ]}
        onChange={handleDateChange}
        locale="sr"
        className={styles.calendarWrap}
      />
    </div>
  );
}
